import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import NaatKhawansPage from './pages/NaatKhawansPage';
import NaatKhawanDetailPage from './pages/NaatKhawanDetailPage';
import NaatDetailsPage from './pages/NaatDetailsPage';
import PopularNaatsPage from './pages/PopularNaatsPage';
import RecentNaatsPage from './pages/RecentNaatsPage';
import FavoriteNaatsPage from './pages/FavoriteNaatsPage';
import SearchResultsPage from './pages/SearchResultsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import NotFoundPage from './pages/NotFoundPage';
import AudioPlayerProvider from './context/AudioPlayerContext';
import ToastProvider from './context/ToastContext';
import { AdminProvider } from './context/AdminContext';
import FavoritesProvider from './context/FavoritesContext';
import { SearchProvider } from './context/SearchContext';
import AdminProtectedRoute from './components/admin/AdminProtectedRoute';
import AdminDashboard from './components/admin/AdminDashboard';
import GlobalAudioPlayer from './components/GlobalAudioPlayer';
import ToastContainer from './components/ToastContainer';
import QueuePanel from './components/QueuePanel';
import ScrollToTop from './components/ScrollToTop';
import { validateConfig } from './config';
import './App.css';

// Validate configuration on app load
validateConfig();

function App() {
  return (
    <ToastProvider>
      <AdminProvider>
        <FavoritesProvider>
          <AudioPlayerProvider>
            <Router>
              <SearchProvider>
                <ScrollToTop />
                <div className="App">
              <Routes>
                {/* Admin Route */}
                <Route 
                  path="/admin" 
                  element={
                    <AdminProtectedRoute>
                      <AdminDashboard />
                    </AdminProtectedRoute>
                  } 
                />
                
                {/* Public Routes */}
                <Route 
                  path="/*" 
                  element={
                    <>
                      <Header />
                      <main className="main-content">
                        <Routes>
                          <Route path="/" element={<HomePage />} />
                          <Route path="/naatkhawans" element={<NaatKhawansPage />} />
                          <Route path="/naatkhawan/:id" element={<NaatKhawanDetailPage />} />
                          <Route path="/naatkhawan/:id/page/:page" element={<NaatKhawanDetailPage />} />
                          <Route path="/naatkhawan/:id/letter/:letter" element={<NaatKhawanDetailPage />} />
                          <Route path="/naatkhawan/:id/letter/:letter/page/:page" element={<NaatKhawanDetailPage />} />
                          <Route path="/naat/:id" element={<NaatDetailsPage />} />
                          <Route path="/popular" element={<PopularNaatsPage />} />
                          <Route path="/popular/page/:page" element={<PopularNaatsPage />} />
                          <Route path="/recent" element={<RecentNaatsPage />} />
                          <Route path="/recent/page/:page" element={<RecentNaatsPage />} />
                          <Route path="/favorites" element={<FavoriteNaatsPage />} />
                          <Route path="/search" element={<SearchResultsPage />} />
                          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                          <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                      </main>
                      <Footer />
                      <GlobalAudioPlayer />
                      <ToastContainer />
                      <QueuePanel />
                    </>
                  } 
                />
              </Routes>
            </div>
              </SearchProvider>
            </Router>
          </AudioPlayerProvider>
        </FavoritesProvider>
      </AdminProvider>
    </ToastProvider>
  );
}

export default App;
